module.exports = __webpack_public_path__ + "img/Deutlich_erhöhte_Aktivität.4e7d14ce.svg";